// Default Functions
import './functions/utm-links'
import './functions/utm-cookies'
import './functions/data-layer'
import './functions/modals'

// Blocks
import '../../blocks/reviews/reviews'
